import { inspect as inspectUtil } from 'util'

const logger = console

export function inspect(title: string, object: any) {
  logger.debug(`↓ ${title} ↓`)
  logger.debug(inspectUtil(object, false, null, true /* enable colors */))
}
